import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function () {
  return {
    dropdown: {},
    itemsWrapper: {
      padding: 4,
      display: "flex",
      width: "100%",
      boxSizing: "border-box"
    }
  };
});
export default useStyles;